import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { motion, useTransform, useScroll } from "framer-motion";

export const SubBanner = ({
  title,
  image,
  image2,
  customBannerColor,
  button,
  className,
  logoBanner = false,
}) => {

  const titleVariants = {
    hidden: { opacity: 0.005, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.05 } },
  };

  return (
    <>
      <section className={`${styles.root} primary-banner mb-5 news-page ${className}`}>
        <Container>
          <div
            className={`content-wrapper rounded-3 shadow position-relative ${
              image2?.url
                ? "dualBannerImage py-lg-5 ps-lg-5  pt-4 ps-4 pb-4"
                : "overflow-hidden p-lg-5 p-4"
            }`}
            style={{ backgroundColor: customBannerColor }}
          >
            {image && image?.url ? (
              <SourceFlowImage
                src={image.url}
                size={`800x`}
                alt={image.alt || "Banner Image"}
                className={`card-img rounded-0 banner-1 position-absolute ${
                  image2?.url
                    ? "rounded-3 shadow slideUp"
                    : "default-banner"
                }`}
                width="100%"
                height="100%"
              />
            ) : (
              ""
            )}
            {image2?.url ? (
              <SourceFlowImage
                src={image2.url}
                size={`800x`}
                alt={image2.alt || "Banner Image"}
                className={`card-img rounded-0 banner-2 position-absolute ${
                  image2?.url
                    ? "rounded-3 shadow slideUp"
                    : "default-banner"
                }`}
                width="100%"
                height="100%"
              />
            ) : (
              ""
            )}
            {button.href && button.label ? (
              <Link href={button.href}>
                <a className="text-decoration-none primaryBtn-outline-white left-arrow rounded-5">
                    {button.label}
                </a>
              </Link>
            ) : (
              button.label ? (
                <span className="d-inline-block primaryBtn-outline-white no-arrow rounded-5 no-cursor">
                  {button.label}
                </span>
              ) : null
            )}

            <motion.h1
              initial="hidden"
              animate="visible"
              variants={titleVariants}
              className="post-title mt-4 mt-md-5 position-relative"
            >
              {title}
            </motion.h1>
          </div>
        </Container>
      </section>
    </>
  );
}

export default SubBanner;
